import type { OperationsLensKey, OperationsPenKey } from "@/api/endpoints";
import { ATTENTION_CLASS, lensLabel } from "../operationsLabels";

/** "Stuck only", "External only", "Stuck · External only" on a card the lenses re-cut; nothing without a lens. */
export function LensTag({ lens, pen }: { lens?: OperationsLensKey; pen?: OperationsPenKey }) {
  const label = lensLabel(lens, pen);
  if (!label) return null;
  return <span className={`ops-lens-tag ${lens ? ATTENTION_CLASS[lens] : pen}`}>{label} only</span>;
}

/** "Not lensed" on a card (or column) that keeps counting the full population while a lens is on. */
export function UnlensedTag() {
  return (
    <span className="ops-unlensed-tag" title="Not affected by the lens: counts everything.">
      not lensed
    </span>
  );
}
